import { firebase } from './firebaseConfig';
const db = firebase.firestore();

// ============== Create a new Post for Firestore ====================
export const newPost = (city, region, country, summary, description, features, sector) => {
  const { uid, displayName } = firebase.auth().currentUser;
  const time = firebase.firestore.Timestamp.fromDate(new Date());

  db.collection('posts').add({
    authorID: uid,
    authorName: displayName,
    city: city,
    country: country, 
    date: time,
    description: description,
    features: features,
    region: region,
    sector: sector, 
    summary: summary
  })
  .then((postRef) => {
    db.collection('posts').doc(postRef.id).collection('writable').doc('upvotes').set({upvotes: 0, upvoters: [], gamifiedUpvotes: 0});
    //This is updating user activity
    db.collection('users').doc(uid).get().then((docRef) => {
      let activity = docRef.data().activity;
      const activityItem = {type: "post", postName: summary, postRef: postRef.id};
      if (activity && activity.length === 10) {
        activity.splice(-1,1);
        activity.unshift(activityItem);
      } else if (activity) activity.unshift(activityItem);
      else activity = [activityItem];

      const increment = firebase.firestore.FieldValue.increment(1); 
      const incrementTwenty = firebase.firestore.FieldValue.increment(20); 
      db.collection('users').doc(uid).update({ numberPosts: increment, activity, numberPoints: incrementTwenty});
    })
  })
  .then(() => firebase.analytics().logEvent('post_create'))
  .catch(function(error) {
    console.error("Error adding document: ", error);
    firebase.analytics().logEvent('post_create_error', {code: error.code, message: error.message});
  });
}

// ======================== Upvote Posts ========================
export const upvotePost = ({upvote, authorID, postID, postUpvoters, summary}) => {
  if (upvote === 1) {
    const increment = firebase.firestore.FieldValue.increment(1); 
    const postRef = db.collection('posts').doc(postID).collection('writable').doc('upvotes');
    const newAuthors = (postUpvoters.length === 0 || postUpvoters[0] === "") ? 
      [authorID] : [...postUpvoters, authorID];

    postRef.update({
      gamifiedUpvotes: increment,
      upvotes: increment,
      upvoters: newAuthors
    })
    .then(() => {
      //This is updating user activity
      db.collection('users').doc(authorID).get().then((docRef) => {
        let activity = docRef.data().activity;
        const activityItem = {type: "upvote", postName: summary, postRef: postID};
        if (activity && activity.length === 10) {
          activity.splice(-1,1);
          activity.unshift(activityItem);
        } else if (activity) activity.unshift(activityItem);
        else activity = [activityItem];
        db.collection('users').doc(authorID).update({ activity });
      });
    })
    .then(() => firebase.analytics().logEvent('post_upvote'))
    .catch(function(error) {
      console.error("Error updating document: ", error);
      firebase.analytics().logEvent('post_upvote_error', {code: error.code, message: error.message});
    });
  } else if (upvote === -1) {
    const decrement = firebase.firestore.FieldValue.increment(-1); 
    const postRef = db.collection('posts').doc(postID).collection('writable').doc('upvotes');
    postRef.update({
      gamifiedUpvotes: decrement,
      upvotes: decrement,
      upvoters: [...postUpvoters.filter(author => authorID !== author)]
    })
    .then(() => firebase.analytics().logEvent('post_unvote'))
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        firebase.analytics().logEvent('post_upvote_error', {code: error.code, message: error.message});
    });
  }
}

function guidGenerator() {
  var S4 = function() {
     return (((1+Math.random())*0x10000)|0).toString(16).substring(1);
  };
  return (S4()+S4()+"-"+S4()+"-"+S4()+"-"+S4()+"-"+S4()+S4()+S4());
}
// =========== CREATE A NEW COMMENT =========================
export async function writeComment({postID, description, comments, setComments, summary, postOwner}) {
  const { uid, displayName } = firebase.auth().currentUser;
  const time = firebase.firestore.Timestamp.fromDate(new Date());
  const guid = guidGenerator();

  db.collection('posts').doc(postID).collection('postComments').doc(guid).set({
    authorID: uid,
    authorName: displayName,
    date: time,
    description, 
    postOwner,
    guid,
    postID
  })
  .then(() => {
    db.collection('posts').doc(postID).collection('postComments').doc(guid).collection('writable').doc('upvotes').set({upvotes: 0, upvoters: []});
    let newComment = {commentID: guid, authorID: uid, authorName: displayName, date: new Date(), description, upvotes: 0, upvoters: []}
    setComments([...comments, newComment]);
    firebase.analytics().logEvent('comment_create')
  })
  .then(() => {
    //This is updating user activity
    db.collection('users').doc(uid).get().then((docRef) => {
      let activity = docRef.data().activity;
      const activityItem = {type: "comment", postName: summary, postRef: postID, content: description};
      if (activity && activity.length === 10) {
        activity.splice(-1,1);
        activity.unshift(activityItem);
      } else if (activity) activity.unshift(activityItem);
      else activity = [activityItem];

      const increment = firebase.firestore.FieldValue.increment(1); 
      const incrementFifteen = firebase.firestore.FieldValue.increment(15); 
      db.collection('users').doc(uid).update({ numberComments: increment, activity, numberPoints: incrementFifteen});
    })
  })
  .catch((error) => {
    console.error(error.code, error.message);
    firebase.analytics().logEvent('comment_create_error', {code: error.code, message: error.message});
  });
}

// =========== UPVOTE COMMENTS =====================
export const upvoteComment = ({upvote, authorID, postID, commentID, upvoters}) => {
  if (upvote === 1) {
    const increment = firebase.firestore.FieldValue.increment(1); 
    const commentRef = db.collection('posts').doc(postID).collection('postComments').doc(commentID).collection('writable').doc('upvotes');
    const newAuthors = (upvoters.length === 0 || upvoters[0] === "") ? 
      [authorID] : [...upvoters, authorID];

    commentRef.update({
      gamifiedUpvotes: increment,
      upvotes: increment,
      upvoters: newAuthors
    })
    .then(() => firebase.analytics().logEvent('comment_upvote'))
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        firebase.analytics().logEvent('comment_upvote_error', {code: error.code, message: error.message});
    });
  } else if (upvote === -1) {
    const decrement = firebase.firestore.FieldValue.increment(-1); 
    const commentRef = db.collection('posts').doc(postID).collection('postComments').doc(commentID).collection('writable').doc('upvotes');
    commentRef.update({
      gamifiedUpvotes: decrement,
      upvotes: decrement,
      upvoters: [...upvoters.filter(author => authorID !== author)]
    })
    .then(() => firebase.analytics().logEvent('comment_unvote'))
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
        firebase.analytics().logEvent('comment_upvote_error', {code: error.code, message: error.message});
    });
  }
}

// ============== DELETE POST ===========================
export async function deletePost(postID, authorID, url) {
  try {
    var deleteFn = firebase.functions().httpsCallable('deletePost');
    deleteFn({ postID })
    .then(() => {
      firebase.analytics().logEvent('post_delete', {postID});
      const decrement = firebase.firestore.FieldValue.increment(-1); 
      const decrementTwenty = firebase.firestore.FieldValue.increment(-20);
      db.collection('users').doc(authorID).update({ numberPosts: decrement, numberPoints: decrementTwenty})
      .then(() => {window.location.href = url});
    });
  }
  catch(error) {
    console.error(error.code, error.message);
    firebase.analytics().logEvent('post_delete_error', {code: error.code, message: error.message});
  }; 
}

// =============== DELETE COMMENT ===================
export function deleteComment(postID, commentID, authorID) {
  const commentRef = db.collection('posts').doc(postID).collection('postComments').doc(commentID)
  commentRef.collection('writable').doc('upvotes').delete();
  commentRef.delete()
    .then(() => {
      const decrement = firebase.firestore.FieldValue.increment(-1); 
      const decrementFifteen = firebase.firestore.FieldValue.increment(-15);
      db.collection('users').doc(authorID).update({ numberComments: decrement, numberPoints: decrementFifteen});
    })
    .catch((error) => {
      console.error(error.code, error.message);
      firebase.analytics().logEvent('comment_delete_error', {code: error.code, message: error.message});
    });

  firebase.analytics().logEvent('comment_delete');
}